<template>
  <div class="about my-4">
    <div class="container">
      <div class="card">
        <div class="card-header text-center bg-primary text-light">
          <h1>Allgemeine Geschäftsbedingungen</h1>
        </div>
        <div class="card-body">
          <div class="card-text">

            <h2>1. Beauftragung eines Frachtführers</h2>
            <p>Der Möbelspediteur kann einen weiteren Frachtführer zur Durchführung des Umzugs heranziehen.</p>

            <h2>2. Zusätzliche Leistungen</h2>
            <p>Der Möbelspediteur führt unter Wahrung des Interesses des Absenders seine Verpflichtungen mit
            der verkehrsüblichen Sorgfalt eines ordentlichen Möbelspediteurs gegen Bezahlung des
            vereinbarten Entgeltes aus. Zusätzlich zu bezahlen sind besondere, bei Vertragsabschluß nicht
            vorhersehbare Leistungen und Aufwendungen. Gleiches gilt, wenn der Leistungsumfang durch
            den Absender nach Vertragsabschluß erweitert wird.</p>

            <h2>3. Trinkgelder</h2>
            <p>Trinkgelder sind mit der Rechnung des Möbelspediteurs nicht verechenbar.</p>

            <h2>4. Erstattung der Umzugskosten</h2>
            <p>Soweit der Absender gegenüber einer Dienststelle oder einem Arbeitgeber einen Anspruch auf
            Umzugskostenvergütung hat, weist er diese Stelle an, die vereinbarte und fällige
            Umzugskostenvergütung abzüglich geleisteter Anzahlungen oder Teilzahlungen auf
            entsprechende Anforderung direkt an den Möbelspediteur auszuzahlen.</p>


            <h2>5. Sicherung besonders transportempfindlicher Güter</h2>
            <p>Der Absender ist verpflichtet, bewegliche oder elektronische Teile an hochempfindlichen
            Geräten wie z. B. Waschmaschinen, Plattenspielern, Fernseh-, Radio- und HIFI-Geräten, EDV-
            Anlagen fachgerecht für den Transport sichern zu lassen. Zur Überprüfung der fachgerechten
            Transportsicherung ist der Möbelspediteur nicht verpflichtet.</p>

            <h2>6. Handwerkervermittlung</h2>
            <p>Bei Leistungen zusätzlich vermittelter Handwerker haftet der Möbelspediteur nur für die
              sorgfältige Auswahl.</p>

            <h2>7. Elektro- und Installationsarbeiten</h2>
            <p>Die Mitarbeiter des Möbelspediteurs sind, sofern nichts anderes vereinbart ist, nicht zur
            Vornahme von Elektro-, Gas-, Dübel- und sonstigen Installationsarbeiten (auch an EDV)
            berechtigt.</p>

            <h2>8. Aufrechnung</h2>
            <p>Gegen Ansprüche des Möbelspediteurs ist eine Aufrechnung nur mit fälligen Gegenansprüchen
            zulässig, die unbestritten oder rechtskräftig sind.</p>

            <h2>9. Abtretung</h2>
            <p>Der Möbelspediteur ist auf Verlangen des Ersatzberechtigten verpflichtet, die ihm aus dem von
            ihm abzuschließenden Versicherungsvertrag zustehenden Rechte an den Ersatzberechtigten
            abzutreten.</p>

            <h2>10. Mißverständnisse</h2>
            <p>Die Gefahr des Mißverständnisses anderer als schriftlicher Auftragsbestätigungen, Weisungen
            und Mitteilungen des Absenders und solche an andere zu ihrer Annahme nicht bevollmächtigte
            Leute des Möbelspediteurs, hat der letztere nicht zu verantworten.</p>

            <h2>11. Nachprüfung durch den Absender</h2>
            <p>Bei Abholung des Umzugsgutes ist der Absender verpflichtet, nachzuprüfen, daß kein
            Gegenstand oder keine Einrichtung irrtümlich mitgenommen oder stehengelassen wird.</p>

            <h2>12. Fälligkeit des vereinbarten Entgelts</h2>
            <p>Der Rechnungsbetrag ist bei Inlandstransporten vor Beendigung der Entladung, bei
            Auslandstransporten vor Beginn der Verladung fällig und in bar oder Form gleichwertiger
            Zahlungsmittel zu bezahlen.
            Barauslagen in ausländischer Währung sind nach dem abgerechneten Wechselkurs zu
            entrichten. Kommt der Absender seiner Zahlungsverpflichtung nicht nach, ist der
            Möbelspediteur berechtigt das Umzugsgut anzuhalten oder nach Beginn auf Kosten des
            Absenders einzulagern § 419 findet entsprechende Anwendung.</p>

            <h2>13. Erstattung im Falle eines Vertrags- Kündigung durch den Auftraggeber</h2>
            <p>
            Im Falle der Kündigung des Auftraggebers steht dem Auftragnehmer gemäß § 415 Abs. 2 HGB
            der Anspruch auf mindestens ein Drittel des für den Transport/ Umzugs geschuldeten Entgelts zu.
            </p>

            <h2>14. Lagervertrag</h2>
            <p>Im Falle der Lagerung gelten die Allgemeinen Lagerbedingungen des Deutschen Möbeltransports
            (ALB). Diese werden auf Verlangen des Absenders zur Verfügung gestellt.</p>

            <h2>15. Gerichtsstand</h2>
            <p>Für Rechtsstreitigkeiten mit Vollkaufleuten auf Grund dieses Vertrages und über Ansprüche aus
anderen Rechtsgründen, die mit dem Transportauftrag zusammenhängen, ist das Gericht in
dessen Bezirk sich die vom Absender beauftragte Niederlassung des Möbelspediteurs befindet,
ausschließlich zuständig. Für Rechtsstreitigkeiten mit anderen als Vollkaufleuten gilt die
ausschließliche Zuständigkeit nur für den Fall, daß der Absender nach Vertragsabschluß seinen
Wohnsitz oder persönlicher Aufenthalt zum Zeitpunkt der Klageerhebung nicht bekannt ist.</p>

<h2>16. Vereinbarung deutschen Rechts</h2>
<p>Es gilt deutsches Recht.</p>

<h1>Haftung des Möbelspediteurs</h1>
<p>Wichtige Informationen zur Haftung des Möbelspediteurs einschließlich Haftungsvereinbarungen, Transportversicherung gem. § 451g HGB</p>
<h2>Anwendungsbereich</h2>
<p>Der Frachtführer (im folgenden Möbelspediteur genannt) haftet nach dem Umzugsvertrag und
dem Handelsgesetzbuch (HGB). Für Beförderungen von Umzugsgut mit Bestimmungsort
außerhalb Deutschlands finden dieselben Haftungsgrundsätze Anwendung. Dies gilt auch, wenn
verschiedenartige Beförderungsmittel zum Einsatz kommen.</p>

<h2>Haftungsgrundsätze</h2>
<p>Der Möbelspediteur haftet für den Schaden, der durch Verlust oder Beschädigung des
Umzugsgutes in der Zeit von der Übernahme zur Beförderung bis zur Ablieferung oder durch
Überschreitung der Lieferfrist entsteht.</p>

<h2>Haftungsausschluß</h2>
<p>Der Möbelspediteur ist von der Haftung befreit, soweit der Verlust, die Beschädigung oder die
Überschreitung der Lieferfrist auf Umständen beruht, die der Möbelspediteur auch bei größter
Sorgfalt nicht vermeiden und deren Folgen er nicht abwenden konnte (unabwendbares
Ereignis).</p>

<h2>Haftungshöchstbetrag</h2>
<p>Die Haftung des Möbelspediteurs wegen Verlust oder Beschädigung ist auf einen Betrag von EUR
613,55 je Kubikmeter Laderaum, der zur Erfüllung des Vertrages benötigt wird beschränkt.
Wegen Überschreitung der Lieferfrist ist die Haftung des Möbelspediteurs auf den dreifachen
Betrag der Fracht begrenzt.. Haftet der Möbelspediteur wegen der Verletzung einer mit der
Ausführung des Umzuges zusammenhängenden vertraglichen Pflicht für Schäden, die nicht
durch Verlust oder Beschädigung des Umzugsgutes aber durch Überschreitung der Lieferfrist
entstehen, und handelt es sich um andere Schäden als Sach- und Personenschäden, so ist in
diesem Fall die Haftung auf das dreifache des Betrages begrenzt, der bei Verlust des Gutes zu
zahlen wäre.Besondere Haftungsausschlußgründe
Der Möbelspediteur ist von seiner Haftung befreit, soweit der Verlust oder die Beschädigung auf
eine der Folgenden Gefahren zurückzuführen ist:
Beförderung von Edelmetallen, Juwelen, Edelsteinen, Gold, Briefmarken, Münzen, Wertpapieren
oder Urkunden.
Ungenügende Verpackung oder Kennzeichnung durch den Absender.
Behandeln, Verladen oder Entladen des Umzugsgutes durch den Absender.
Beförderung von nicht vom Möbelspediteur verpackten Gut in Behältern.
Verladen oder entladen von Umzugsgut, dessen Größe oder Gewicht den Raumverhältnissen an
der Ladestelle oder Entlade stelle nicht entspricht, sofern der Möbelspediteur den Absender auf
die Gefahr einer Beschädigung vorher hingewiesen und der Absender auf die Durchführung der
Leistung bestanden hat. Beförderung lebender Tiere oder Pflanzen. Natürliche oder mangelhafte
Beschaffenheit des Umzugsgutes, der zufolge es besonders leicht Schäden, insbesondere Durch
Beulen, Funktionsstörungen, Rost, inneren Verderb oder Auslaufen erleidet.
Ist ein Schaden eingetreten, der nach den Umständen des Falles aus einer der in Ziffern 1 – 7
bezeichneten Gefahren entstehen konnte, so wird vermutet, daß der Schaden aus dieser Gefahr
entstanden ist. Der Möbelspediteur kann sich auf die besonderen Haftungsabschlußgründe nur
berufen, wenn er alle ihm nach den Umständen anliegenden Maßnahmen getroffen und
besondere Weisungen beachtet hat.</p>

<h2>Wertersatz</h2>
<p>Hat der Möbelspediteur Schadenersatz wegen Verlust zu leisten, so ist der Wert am Ort und zur
Zeit der Übernahme zur Beförderung zu ersetzen. Bei Beschädigung des Gutes ist derUnterschied zwischen dem Wert des unbeschädigten Gutes und dem Wert des beschädigten
Gutes zu ersetzen. Dabei kommt es auf Ort und Zeitpunkt der Übernahme des Gutes zur
Beförderung an. Der Wert des Umzugsgutes begrenzt sich in der Regel nach dem Marktpreis.
Zusätzlich sind die Kosten der Schadenfeststellung zu ersetzen.</p>

<h2>Außervertragliche Ansprüche</h2>
<p>Die Haftungsbefreiungen und Haftungsbegrenzungen gelten auch für einen außervertraglichen
Anspruch des Absenders oder des Empfängers gegen den Möbelspediteur wegen Verlust oder
Beschädigung des Umzugsgutes oder wegen Überschreitung der Lieferfrist.</p>

<h2>Wegfall der Haftungsbefreiungen und -begrenzungen</h2>
<p>Die Haftungsbefreiungen und Haftungsbegrenzungen gelten nicht, wenn der Schaden auf eine
Handlung oder Unterlassung zurückzuführen ist, die der Möbelspediteur vorsätzlich oder
leichtfertig und in dem Bewußtsein, daß ein Schaden mit Wahrscheinlichkeit eintreten werde
begangen hat.</p>

<h2>Haftung der Leute</h2>
<p>Werden Schadenersatzansprüche aus außervertraglicher Haftung wegen Verlust oder
Beschädigung des Umzugsgutes oder wegen Überschreitung der Lieferfrist gegen einen der
Leute des Möbelspediteurs erhoben, so kann sich auch jener auf die Haftungsbefreiungen und -
begrenzungen berufen. Das gilt nicht, wenn er vorsätzlich oder leichtfertig und in dem
Bewußtsein, daß ein Schaden mit Wahrscheinlichkeit eintreten werde, gehandelt hat.</p>

<h2>Ausführender Möbelspediteur</h2>
<p>Wird der Umzug ganz oder teilweise durch den einen Dritten ausgeführt (ausführender
Möbelspediteur), so haftet dieser für den Schaden der durch Verlust oder Beschädigung des
Gutes oder durch Überschreitung der Lieferfrist während der durch ihn ausgeführten
Beförderung entsteht, in gleicher Weise wie der Möbelspediteur.
Der ausführende Möbelspediteur kann alle Einwendungen geltend machen, die dem
Möbelspediteur aus dem Frachtvertrag zustehen. Werden Leute des ausführenden
Möbelspediteurs in Anspruch genommen, so gelten für diese die Bestimmungen über die
Haftung der Leute.</p>

<h2>Haftungsvereinbarung</h2>
<p>Der Möbelspediteur weist den Absender auf die Möglichkeit hin, mit ihm gegen Bezahlung eines
entsprechenden Entgelts eine weitergehende als die gesetzlich vorgesehene Haftung zu
vereinbaren.</p>

<h2>Transportversicherung</h2>
<p>Der Möbelspediteur weist den Absender auf die Möglichkeit hin, das Gut gegen Bezahlung einer
gesonderten Prämie zu versichern.</p>

<h2>Schadensanzeige</h2>
<p>Um das Erlöschen von Ersatzansprüchen zu verhindern, ist folgendes zu beachten: Untersuchen
sie das Gut bei Ablieferung auf äußerlich erkennbare Beschädigungen oder Verluste. Halten Sie
diese auf der Empfangsbescheinigung bzw. einem Schadenprotokoll spezifiziert fast oder zeigen
Sie diese dem Möbelspediteur spätestens am Tage nach der Ablieferung an.Äußerlich nicht
erkennbare Beschädigungen oder Verluste müssen dem Möbelspediteur innerhalb von 14 Tagen
nach spezifiziert angezeigt werden.Pauschale Schadensanzeigen genügen in keinem Fall.
Ansprüche wegen Überschreitung der Lieferfristen erlöschen, wenn der Empfänger dem
Möbelspediteur die Überschreitung der Lieferfrist nicht innerhalb von 21 Tagen nach Ablieferung
anzeigt.Wird die Anzeige nach Ablieferung erstattet, muß die um den Anspruchsverlust zu
verhindern in jedem Fall in schriftlicher Form und innerhalb der vorgesehenen Fristen erfolgen.
Die Übermittlung der Schadensanzeige kann auch mit Hilfe der telekommunikativen Einrichtung
erfolgen. Einer Unterschrift bedarf es nicht, wenn der Aussteller in anderer Weise erkennbar
ist.Zur Wahrung der Fristen genügt die rechtzeitige Absendung.</p>

<h2>Gefährliches Umzugsgut</h2>
<p>Zählt zu dem Umzugsgut gefährliches Gut (z. B. Benzin oder Öle), ist der Absender verpflichtet,
dem Möbelspediteur rechtzeitig anzugeben, welcher Natur die Gefahr ist, die von dem Gut
ausgeht (z. B. Feuergefährlichkeit, ätzende Flüssigkeit, explosive Stoffe, etc.)</p>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import { useMeta } from 'vue-meta'
import { useRoute } from 'vue-router'

export default {
  name: 'Agb',
  components: {

  },
  setup() {
    var description = 'Alle Informationen zu den Allgemeinen Geschäftsbedingungen finden Sie auf dieser Seite. Sollten Sie weitere Fragen haben, beantworten wir diese gerne!'
    var title = 'Allgemeine Geschäftsbedingungen | umzug-bayern.com'
    var keywords = 'AGB, Allgemeine Geschäftsbedingungen'
    var route = useRoute()
    var url = process.env.VUE_APP_URL + route.path
    useMeta({
      title: title,
      description: description,
      keywords: keywords,
      link: {
        rel: "canonical",
        href: url
      },
      og: {
        type: "website",
        title: title,
        url: url,
        description: description,
        site_name: process.env.VUE_APP_NAME
      },
      twitter: {
        card: "summary",
        title: title,
        url: url,
        description: description,
        label1: "Geschätzte Lesezeit",
        data1: "5 Minuten"
      },
      robots: "noindex, nofollow"
    })
  }
}
</script>
